// Guardian AI Fraud Service Protocol Definitions
// Fraud detection, reporting, and analytics
//
// Version: v1
// Source: Merged from fraud_detection.proto + user_services.proto FraudReportService

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/fraud/fraud.proto (package guardianai.v1.fraud, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/fraud/fraud.proto.
 */
export const file_guardianai_v1_fraud_fraud: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message guardianai.v1.fraud.AnalyzeSubmissionRequest
 */
export type AnalyzeSubmissionRequest = Message<"guardianai.v1.fraud.AnalyzeSubmissionRequest"> & {
  /**
   * @generated from field: string submission_id = 1;
   */
  submissionId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string content = 3;
   */
  content: string;

  /**
   * @generated from field: map<string, string> metadata = 4;
   */
  metadata: { [key: string]: string };
};

/**
 * @generated from message guardianai.v1.fraud.AnalyzeSubmissionRequest
 */
export type AnalyzeSubmissionRequestJson = {
  /**
   * @generated from field: string submission_id = 1;
   */
  submissionId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: string content = 3;
   */
  content?: string;

  /**
   * @generated from field: map<string, string> metadata = 4;
   */
  metadata?: { [key: string]: string };
};

/**
 * Describes the message guardianai.v1.fraud.AnalyzeSubmissionRequest.
 * Use `create(AnalyzeSubmissionRequestSchema)` to create a new message.
 */
export const AnalyzeSubmissionRequestSchema: GenMessage<AnalyzeSubmissionRequest, {jsonType: AnalyzeSubmissionRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 0);

/**
 * @generated from message guardianai.v1.fraud.FraudAnalysisResponse
 */
export type FraudAnalysisResponse = Message<"guardianai.v1.fraud.FraudAnalysisResponse"> & {
  /**
   * @generated from field: string submission_id = 1;
   */
  submissionId: string;

  /**
   * @generated from field: double fraud_score = 2;
   */
  fraudScore: number;

  /**
   * @generated from field: string risk_level = 3;
   */
  riskLevel: string;

  /**
   * @generated from field: repeated guardianai.v1.fraud.FraudSignal signals = 4;
   */
  signals: FraudSignal[];

  /**
   * @generated from field: string recommendation = 5;
   */
  recommendation: string;

  /**
   * @generated from field: int64 analyzed_at = 6;
   */
  analyzedAt: bigint;
};

/**
 * @generated from message guardianai.v1.fraud.FraudAnalysisResponse
 */
export type FraudAnalysisResponseJson = {
  /**
   * @generated from field: string submission_id = 1;
   */
  submissionId?: string;

  /**
   * @generated from field: double fraud_score = 2;
   */
  fraudScore?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: string risk_level = 3;
   */
  riskLevel?: string;

  /**
   * @generated from field: repeated guardianai.v1.fraud.FraudSignal signals = 4;
   */
  signals?: FraudSignalJson[];

  /**
   * @generated from field: string recommendation = 5;
   */
  recommendation?: string;

  /**
   * @generated from field: int64 analyzed_at = 6;
   */
  analyzedAt?: string;
};

/**
 * Describes the message guardianai.v1.fraud.FraudAnalysisResponse.
 * Use `create(FraudAnalysisResponseSchema)` to create a new message.
 */
export const FraudAnalysisResponseSchema: GenMessage<FraudAnalysisResponse, {jsonType: FraudAnalysisResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 1);

/**
 * @generated from message guardianai.v1.fraud.FraudSignal
 */
export type FraudSignal = Message<"guardianai.v1.fraud.FraudSignal"> & {
  /**
   * @generated from field: string signal_type = 1;
   */
  signalType: string;

  /**
   * @generated from field: double confidence = 2;
   */
  confidence: number;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string evidence = 4;
   */
  evidence: string;
};

/**
 * @generated from message guardianai.v1.fraud.FraudSignal
 */
export type FraudSignalJson = {
  /**
   * @generated from field: string signal_type = 1;
   */
  signalType?: string;

  /**
   * @generated from field: double confidence = 2;
   */
  confidence?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: string evidence = 4;
   */
  evidence?: string;
};

/**
 * Describes the message guardianai.v1.fraud.FraudSignal.
 * Use `create(FraudSignalSchema)` to create a new message.
 */
export const FraudSignalSchema: GenMessage<FraudSignal, {jsonType: FraudSignalJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 2);

/**
 * @generated from message guardianai.v1.fraud.GetFraudPatternsRequest
 */
export type GetFraudPatternsRequest = Message<"guardianai.v1.fraud.GetFraudPatternsRequest"> & {
  /**
   * @generated from field: string category = 1;
   */
  category: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.fraud.GetFraudPatternsRequest
 */
export type GetFraudPatternsRequestJson = {
  /**
   * @generated from field: string category = 1;
   */
  category?: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.fraud.GetFraudPatternsRequest.
 * Use `create(GetFraudPatternsRequestSchema)` to create a new message.
 */
export const GetFraudPatternsRequestSchema: GenMessage<GetFraudPatternsRequest, {jsonType: GetFraudPatternsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 3);

/**
 * @generated from message guardianai.v1.fraud.FraudPatternsResponse
 */
export type FraudPatternsResponse = Message<"guardianai.v1.fraud.FraudPatternsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.fraud.FraudPattern patterns = 1;
   */
  patterns: FraudPattern[];
};

/**
 * @generated from message guardianai.v1.fraud.FraudPatternsResponse
 */
export type FraudPatternsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.fraud.FraudPattern patterns = 1;
   */
  patterns?: FraudPatternJson[];
};

/**
 * Describes the message guardianai.v1.fraud.FraudPatternsResponse.
 * Use `create(FraudPatternsResponseSchema)` to create a new message.
 */
export const FraudPatternsResponseSchema: GenMessage<FraudPatternsResponse, {jsonType: FraudPatternsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 4);

/**
 * @generated from message guardianai.v1.fraud.FraudPattern
 */
export type FraudPattern = Message<"guardianai.v1.fraud.FraudPattern"> & {
  /**
   * @generated from field: string pattern_id = 1;
   */
  patternId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: int32 occurrence_count = 4;
   */
  occurrenceCount: number;

  /**
   * @generated from field: double severity = 5;
   */
  severity: number;
};

/**
 * @generated from message guardianai.v1.fraud.FraudPattern
 */
export type FraudPatternJson = {
  /**
   * @generated from field: string pattern_id = 1;
   */
  patternId?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: int32 occurrence_count = 4;
   */
  occurrenceCount?: number;

  /**
   * @generated from field: double severity = 5;
   */
  severity?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message guardianai.v1.fraud.FraudPattern.
 * Use `create(FraudPatternSchema)` to create a new message.
 */
export const FraudPatternSchema: GenMessage<FraudPattern, {jsonType: FraudPatternJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 5);

/**
 * @generated from message guardianai.v1.fraud.ReportFraudRequest
 */
export type ReportFraudRequest = Message<"guardianai.v1.fraud.ReportFraudRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string entity_type = 2;
   */
  entityType: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * @generated from field: string evidence = 4;
   */
  evidence: string;

  /**
   * @generated from field: string reporter_id = 5;
   */
  reporterId: string;
};

/**
 * @generated from message guardianai.v1.fraud.ReportFraudRequest
 */
export type ReportFraudRequestJson = {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId?: string;

  /**
   * @generated from field: string entity_type = 2;
   */
  entityType?: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason?: string;

  /**
   * @generated from field: string evidence = 4;
   */
  evidence?: string;

  /**
   * @generated from field: string reporter_id = 5;
   */
  reporterId?: string;
};

/**
 * Describes the message guardianai.v1.fraud.ReportFraudRequest.
 * Use `create(ReportFraudRequestSchema)` to create a new message.
 */
export const ReportFraudRequestSchema: GenMessage<ReportFraudRequest, {jsonType: ReportFraudRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 6);

/**
 * @generated from message guardianai.v1.fraud.ReportFraudResponse
 */
export type ReportFraudResponse = Message<"guardianai.v1.fraud.ReportFraudResponse"> & {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId: string;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;

  /**
   * @generated from field: string message = 3;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.fraud.ReportFraudResponse
 */
export type ReportFraudResponseJson = {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId?: string;

  /**
   * @generated from field: bool success = 2;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 3;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.fraud.ReportFraudResponse.
 * Use `create(ReportFraudResponseSchema)` to create a new message.
 */
export const ReportFraudResponseSchema: GenMessage<ReportFraudResponse, {jsonType: ReportFraudResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 7);

/**
 * @generated from message guardianai.v1.fraud.GetFraudStatsRequest
 */
export type GetFraudStatsRequest = Message<"guardianai.v1.fraud.GetFraudStatsRequest"> & {
  /**
   * @generated from field: int64 start_time = 1;
   */
  startTime: bigint;

  /**
   * @generated from field: int64 end_time = 2;
   */
  endTime: bigint;
};

/**
 * @generated from message guardianai.v1.fraud.GetFraudStatsRequest
 */
export type GetFraudStatsRequestJson = {
  /**
   * @generated from field: int64 start_time = 1;
   */
  startTime?: string;

  /**
   * @generated from field: int64 end_time = 2;
   */
  endTime?: string;
};

/**
 * Describes the message guardianai.v1.fraud.GetFraudStatsRequest.
 * Use `create(GetFraudStatsRequestSchema)` to create a new message.
 */
export const GetFraudStatsRequestSchema: GenMessage<GetFraudStatsRequest, {jsonType: GetFraudStatsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 8);

/**
 * @generated from message guardianai.v1.fraud.FraudStatsResponse
 */
export type FraudStatsResponse = Message<"guardianai.v1.fraud.FraudStatsResponse"> & {
  /**
   * @generated from field: int64 total_analyzed = 1;
   */
  totalAnalyzed: bigint;

  /**
   * @generated from field: int64 fraud_detected = 2;
   */
  fraudDetected: bigint;

  /**
   * @generated from field: double detection_rate = 3;
   */
  detectionRate: number;

  /**
   * @generated from field: map<string, int64> by_category = 4;
   */
  byCategory: { [key: string]: bigint };
};

/**
 * @generated from message guardianai.v1.fraud.FraudStatsResponse
 */
export type FraudStatsResponseJson = {
  /**
   * @generated from field: int64 total_analyzed = 1;
   */
  totalAnalyzed?: string;

  /**
   * @generated from field: int64 fraud_detected = 2;
   */
  fraudDetected?: string;

  /**
   * @generated from field: double detection_rate = 3;
   */
  detectionRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: map<string, int64> by_category = 4;
   */
  byCategory?: { [key: string]: string };
};

/**
 * Describes the message guardianai.v1.fraud.FraudStatsResponse.
 * Use `create(FraudStatsResponseSchema)` to create a new message.
 */
export const FraudStatsResponseSchema: GenMessage<FraudStatsResponse, {jsonType: FraudStatsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 9);

/**
 * @generated from message guardianai.v1.fraud.CheckVelocityRequest
 */
export type CheckVelocityRequest = Message<"guardianai.v1.fraud.CheckVelocityRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string action_type = 2;
   */
  actionType: string;

  /**
   * @generated from field: int32 window_seconds = 3;
   */
  windowSeconds: number;
};

/**
 * @generated from message guardianai.v1.fraud.CheckVelocityRequest
 */
export type CheckVelocityRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string action_type = 2;
   */
  actionType?: string;

  /**
   * @generated from field: int32 window_seconds = 3;
   */
  windowSeconds?: number;
};

/**
 * Describes the message guardianai.v1.fraud.CheckVelocityRequest.
 * Use `create(CheckVelocityRequestSchema)` to create a new message.
 */
export const CheckVelocityRequestSchema: GenMessage<CheckVelocityRequest, {jsonType: CheckVelocityRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 10);

/**
 * @generated from message guardianai.v1.fraud.VelocityResponse
 */
export type VelocityResponse = Message<"guardianai.v1.fraud.VelocityResponse"> & {
  /**
   * @generated from field: int32 action_count = 1;
   */
  actionCount: number;

  /**
   * @generated from field: bool exceeded_limit = 2;
   */
  exceededLimit: boolean;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: int32 remaining = 4;
   */
  remaining: number;
};

/**
 * @generated from message guardianai.v1.fraud.VelocityResponse
 */
export type VelocityResponseJson = {
  /**
   * @generated from field: int32 action_count = 1;
   */
  actionCount?: number;

  /**
   * @generated from field: bool exceeded_limit = 2;
   */
  exceededLimit?: boolean;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit?: number;

  /**
   * @generated from field: int32 remaining = 4;
   */
  remaining?: number;
};

/**
 * Describes the message guardianai.v1.fraud.VelocityResponse.
 * Use `create(VelocityResponseSchema)` to create a new message.
 */
export const VelocityResponseSchema: GenMessage<VelocityResponse, {jsonType: VelocityResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 11);

/**
 * @generated from message guardianai.v1.fraud.SubmitReportRequest
 */
export type SubmitReportRequest = Message<"guardianai.v1.fraud.SubmitReportRequest"> & {
  /**
   * @generated from field: string reporter_id = 1;
   */
  reporterId: string;

  /**
   * The entity being reported (alias: accused_entity_id)
   *
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * Type of entity (alias: accused_entity_type)
   *
   * @generated from field: string entity_type = 3;
   */
  entityType: string;

  /**
   * Fraud category (alias: initial_category)
   *
   * @generated from field: string category = 4;
   */
  category: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: repeated string evidence_urls = 6;
   */
  evidenceUrls: string[];

  /**
   * Semantic aliases for clearer frontend usage
   *
   * Same as entity_id, clearer naming
   *
   * @generated from field: string accused_entity_id = 7;
   */
  accusedEntityId: string;

  /**
   * Same as entity_type, clearer naming
   *
   * @generated from field: string accused_entity_type = 8;
   */
  accusedEntityType: string;

  /**
   * Same as category, clearer naming
   *
   * @generated from field: string initial_category = 9;
   */
  initialCategory: string;
};

/**
 * @generated from message guardianai.v1.fraud.SubmitReportRequest
 */
export type SubmitReportRequestJson = {
  /**
   * @generated from field: string reporter_id = 1;
   */
  reporterId?: string;

  /**
   * The entity being reported (alias: accused_entity_id)
   *
   * @generated from field: string entity_id = 2;
   */
  entityId?: string;

  /**
   * Type of entity (alias: accused_entity_type)
   *
   * @generated from field: string entity_type = 3;
   */
  entityType?: string;

  /**
   * Fraud category (alias: initial_category)
   *
   * @generated from field: string category = 4;
   */
  category?: string;

  /**
   * @generated from field: string description = 5;
   */
  description?: string;

  /**
   * @generated from field: repeated string evidence_urls = 6;
   */
  evidenceUrls?: string[];

  /**
   * Semantic aliases for clearer frontend usage
   *
   * Same as entity_id, clearer naming
   *
   * @generated from field: string accused_entity_id = 7;
   */
  accusedEntityId?: string;

  /**
   * Same as entity_type, clearer naming
   *
   * @generated from field: string accused_entity_type = 8;
   */
  accusedEntityType?: string;

  /**
   * Same as category, clearer naming
   *
   * @generated from field: string initial_category = 9;
   */
  initialCategory?: string;
};

/**
 * Describes the message guardianai.v1.fraud.SubmitReportRequest.
 * Use `create(SubmitReportRequestSchema)` to create a new message.
 */
export const SubmitReportRequestSchema: GenMessage<SubmitReportRequest, {jsonType: SubmitReportRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 12);

/**
 * @generated from message guardianai.v1.fraud.FraudReportResponse
 */
export type FraudReportResponse = Message<"guardianai.v1.fraud.FraudReportResponse"> & {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string category = 3;
   */
  category: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: int64 created_at = 5;
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 updated_at = 6;
   */
  updatedAt: bigint;

  /**
   * Extended fields for frontend display
   *
   * LOW, MEDIUM, HIGH, CRITICAL
   *
   * @generated from field: string severity = 7;
   */
  severity: string;

  /**
   * @generated from field: string accused_entity_id = 8;
   */
  accusedEntityId: string;

  /**
   * @generated from field: string accused_entity_type = 9;
   */
  accusedEntityType: string;

  /**
   * @generated from field: repeated string evidence_urls = 10;
   */
  evidenceUrls: string[];

  /**
   * @generated from field: string reporter_id = 11;
   */
  reporterId: string;

  /**
   * @generated from field: string resolution = 12;
   */
  resolution: string;

  /**
   * @generated from field: string assigned_investigator_id = 13;
   */
  assignedInvestigatorId: string;

  /**
   * Comments on the report
   *
   * @generated from field: repeated guardianai.v1.fraud.CommentResponse comments = 14;
   */
  comments: CommentResponse[];
};

/**
 * @generated from message guardianai.v1.fraud.FraudReportResponse
 */
export type FraudReportResponseJson = {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId?: string;

  /**
   * @generated from field: string status = 2;
   */
  status?: string;

  /**
   * @generated from field: string category = 3;
   */
  category?: string;

  /**
   * @generated from field: string description = 4;
   */
  description?: string;

  /**
   * @generated from field: int64 created_at = 5;
   */
  createdAt?: string;

  /**
   * @generated from field: int64 updated_at = 6;
   */
  updatedAt?: string;

  /**
   * Extended fields for frontend display
   *
   * LOW, MEDIUM, HIGH, CRITICAL
   *
   * @generated from field: string severity = 7;
   */
  severity?: string;

  /**
   * @generated from field: string accused_entity_id = 8;
   */
  accusedEntityId?: string;

  /**
   * @generated from field: string accused_entity_type = 9;
   */
  accusedEntityType?: string;

  /**
   * @generated from field: repeated string evidence_urls = 10;
   */
  evidenceUrls?: string[];

  /**
   * @generated from field: string reporter_id = 11;
   */
  reporterId?: string;

  /**
   * @generated from field: string resolution = 12;
   */
  resolution?: string;

  /**
   * @generated from field: string assigned_investigator_id = 13;
   */
  assignedInvestigatorId?: string;

  /**
   * Comments on the report
   *
   * @generated from field: repeated guardianai.v1.fraud.CommentResponse comments = 14;
   */
  comments?: CommentResponseJson[];
};

/**
 * Describes the message guardianai.v1.fraud.FraudReportResponse.
 * Use `create(FraudReportResponseSchema)` to create a new message.
 */
export const FraudReportResponseSchema: GenMessage<FraudReportResponse, {jsonType: FraudReportResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 13);

/**
 * @generated from message guardianai.v1.fraud.GetReportRequest
 */
export type GetReportRequest = Message<"guardianai.v1.fraud.GetReportRequest"> & {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId: string;
};

/**
 * @generated from message guardianai.v1.fraud.GetReportRequest
 */
export type GetReportRequestJson = {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId?: string;
};

/**
 * Describes the message guardianai.v1.fraud.GetReportRequest.
 * Use `create(GetReportRequestSchema)` to create a new message.
 */
export const GetReportRequestSchema: GenMessage<GetReportRequest, {jsonType: GetReportRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 14);

/**
 * @generated from message guardianai.v1.fraud.UpdateReportRequest
 */
export type UpdateReportRequest = Message<"guardianai.v1.fraud.UpdateReportRequest"> & {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string resolution = 3;
   */
  resolution: string;
};

/**
 * @generated from message guardianai.v1.fraud.UpdateReportRequest
 */
export type UpdateReportRequestJson = {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId?: string;

  /**
   * @generated from field: string status = 2;
   */
  status?: string;

  /**
   * @generated from field: string resolution = 3;
   */
  resolution?: string;
};

/**
 * Describes the message guardianai.v1.fraud.UpdateReportRequest.
 * Use `create(UpdateReportRequestSchema)` to create a new message.
 */
export const UpdateReportRequestSchema: GenMessage<UpdateReportRequest, {jsonType: UpdateReportRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 15);

/**
 * @generated from message guardianai.v1.fraud.ListReportsRequest
 */
export type ListReportsRequest = Message<"guardianai.v1.fraud.ListReportsRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 4;
   */
  offset: number;
};

/**
 * @generated from message guardianai.v1.fraud.ListReportsRequest
 */
export type ListReportsRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string status = 2;
   */
  status?: string;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit?: number;

  /**
   * @generated from field: int32 offset = 4;
   */
  offset?: number;
};

/**
 * Describes the message guardianai.v1.fraud.ListReportsRequest.
 * Use `create(ListReportsRequestSchema)` to create a new message.
 */
export const ListReportsRequestSchema: GenMessage<ListReportsRequest, {jsonType: ListReportsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 16);

/**
 * @generated from message guardianai.v1.fraud.ListReportsResponse
 */
export type ListReportsResponse = Message<"guardianai.v1.fraud.ListReportsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.fraud.FraudReportResponse reports = 1;
   */
  reports: FraudReportResponse[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.fraud.ListReportsResponse
 */
export type ListReportsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.fraud.FraudReportResponse reports = 1;
   */
  reports?: FraudReportResponseJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.fraud.ListReportsResponse.
 * Use `create(ListReportsResponseSchema)` to create a new message.
 */
export const ListReportsResponseSchema: GenMessage<ListReportsResponse, {jsonType: ListReportsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 17);

/**
 * @generated from message guardianai.v1.fraud.GetReportAnalyticsRequest
 */
export type GetReportAnalyticsRequest = Message<"guardianai.v1.fraud.GetReportAnalyticsRequest"> & {
  /**
   * @generated from field: int64 start_time = 1;
   */
  startTime: bigint;

  /**
   * @generated from field: int64 end_time = 2;
   */
  endTime: bigint;
};

/**
 * @generated from message guardianai.v1.fraud.GetReportAnalyticsRequest
 */
export type GetReportAnalyticsRequestJson = {
  /**
   * @generated from field: int64 start_time = 1;
   */
  startTime?: string;

  /**
   * @generated from field: int64 end_time = 2;
   */
  endTime?: string;
};

/**
 * Describes the message guardianai.v1.fraud.GetReportAnalyticsRequest.
 * Use `create(GetReportAnalyticsRequestSchema)` to create a new message.
 */
export const GetReportAnalyticsRequestSchema: GenMessage<GetReportAnalyticsRequest, {jsonType: GetReportAnalyticsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 18);

/**
 * @generated from message guardianai.v1.fraud.ReportAnalyticsResponse
 */
export type ReportAnalyticsResponse = Message<"guardianai.v1.fraud.ReportAnalyticsResponse"> & {
  /**
   * @generated from field: int32 total_reports = 1;
   */
  totalReports: number;

  /**
   * @generated from field: int32 resolved = 2;
   */
  resolved: number;

  /**
   * @generated from field: int32 pending = 3;
   */
  pending: number;

  /**
   * @generated from field: map<string, int32> by_category = 4;
   */
  byCategory: { [key: string]: number };
};

/**
 * @generated from message guardianai.v1.fraud.ReportAnalyticsResponse
 */
export type ReportAnalyticsResponseJson = {
  /**
   * @generated from field: int32 total_reports = 1;
   */
  totalReports?: number;

  /**
   * @generated from field: int32 resolved = 2;
   */
  resolved?: number;

  /**
   * @generated from field: int32 pending = 3;
   */
  pending?: number;

  /**
   * @generated from field: map<string, int32> by_category = 4;
   */
  byCategory?: { [key: string]: number };
};

/**
 * Describes the message guardianai.v1.fraud.ReportAnalyticsResponse.
 * Use `create(ReportAnalyticsResponseSchema)` to create a new message.
 */
export const ReportAnalyticsResponseSchema: GenMessage<ReportAnalyticsResponse, {jsonType: ReportAnalyticsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 19);

/**
 * @generated from message guardianai.v1.fraud.GetFraudCategoriesRequest
 */
export type GetFraudCategoriesRequest = Message<"guardianai.v1.fraud.GetFraudCategoriesRequest"> & {
};

/**
 * @generated from message guardianai.v1.fraud.GetFraudCategoriesRequest
 */
export type GetFraudCategoriesRequestJson = {
};

/**
 * Describes the message guardianai.v1.fraud.GetFraudCategoriesRequest.
 * Use `create(GetFraudCategoriesRequestSchema)` to create a new message.
 */
export const GetFraudCategoriesRequestSchema: GenMessage<GetFraudCategoriesRequest, {jsonType: GetFraudCategoriesRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 20);

/**
 * @generated from message guardianai.v1.fraud.FraudCategoriesResponse
 */
export type FraudCategoriesResponse = Message<"guardianai.v1.fraud.FraudCategoriesResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.fraud.FraudCategory categories = 1;
   */
  categories: FraudCategory[];
};

/**
 * @generated from message guardianai.v1.fraud.FraudCategoriesResponse
 */
export type FraudCategoriesResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.fraud.FraudCategory categories = 1;
   */
  categories?: FraudCategoryJson[];
};

/**
 * Describes the message guardianai.v1.fraud.FraudCategoriesResponse.
 * Use `create(FraudCategoriesResponseSchema)` to create a new message.
 */
export const FraudCategoriesResponseSchema: GenMessage<FraudCategoriesResponse, {jsonType: FraudCategoriesResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 21);

/**
 * @generated from message guardianai.v1.fraud.FraudCategory
 */
export type FraudCategory = Message<"guardianai.v1.fraud.FraudCategory"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string parent_id = 4;
   */
  parentId: string;

  /**
   * Aliases for frontend select/option compatibility
   *
   * Alias for id
   *
   * @generated from field: string value = 5;
   */
  value: string;

  /**
   * Alias for name
   *
   * @generated from field: string label = 6;
   */
  label: string;
};

/**
 * @generated from message guardianai.v1.fraud.FraudCategory
 */
export type FraudCategoryJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: string parent_id = 4;
   */
  parentId?: string;

  /**
   * Aliases for frontend select/option compatibility
   *
   * Alias for id
   *
   * @generated from field: string value = 5;
   */
  value?: string;

  /**
   * Alias for name
   *
   * @generated from field: string label = 6;
   */
  label?: string;
};

/**
 * Describes the message guardianai.v1.fraud.FraudCategory.
 * Use `create(FraudCategorySchema)` to create a new message.
 */
export const FraudCategorySchema: GenMessage<FraudCategory, {jsonType: FraudCategoryJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 22);

/**
 * @generated from message guardianai.v1.fraud.GetUserReportsRequest
 */
export type GetUserReportsRequest = Message<"guardianai.v1.fraud.GetUserReportsRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;
};

/**
 * @generated from message guardianai.v1.fraud.GetUserReportsRequest
 */
export type GetUserReportsRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: int32 offset = 3;
   */
  offset?: number;
};

/**
 * Describes the message guardianai.v1.fraud.GetUserReportsRequest.
 * Use `create(GetUserReportsRequestSchema)` to create a new message.
 */
export const GetUserReportsRequestSchema: GenMessage<GetUserReportsRequest, {jsonType: GetUserReportsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 23);

/**
 * @generated from message guardianai.v1.fraud.GetInvestigatorReportsRequest
 */
export type GetInvestigatorReportsRequest = Message<"guardianai.v1.fraud.GetInvestigatorReportsRequest"> & {
  /**
   * @generated from field: string investigator_id = 1;
   */
  investigatorId: string;

  /**
   * @generated from field: string status_filter = 2;
   */
  statusFilter: string;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 4;
   */
  offset: number;
};

/**
 * @generated from message guardianai.v1.fraud.GetInvestigatorReportsRequest
 */
export type GetInvestigatorReportsRequestJson = {
  /**
   * @generated from field: string investigator_id = 1;
   */
  investigatorId?: string;

  /**
   * @generated from field: string status_filter = 2;
   */
  statusFilter?: string;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit?: number;

  /**
   * @generated from field: int32 offset = 4;
   */
  offset?: number;
};

/**
 * Describes the message guardianai.v1.fraud.GetInvestigatorReportsRequest.
 * Use `create(GetInvestigatorReportsRequestSchema)` to create a new message.
 */
export const GetInvestigatorReportsRequestSchema: GenMessage<GetInvestigatorReportsRequest, {jsonType: GetInvestigatorReportsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 24);

/**
 * @generated from message guardianai.v1.fraud.UpdateReportStatusRequest
 */
export type UpdateReportStatusRequest = Message<"guardianai.v1.fraud.UpdateReportStatusRequest"> & {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId: string;

  /**
   * @generated from field: string new_status = 2;
   */
  newStatus: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * @generated from field: string updated_by = 4;
   */
  updatedBy: string;
};

/**
 * @generated from message guardianai.v1.fraud.UpdateReportStatusRequest
 */
export type UpdateReportStatusRequestJson = {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId?: string;

  /**
   * @generated from field: string new_status = 2;
   */
  newStatus?: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason?: string;

  /**
   * @generated from field: string updated_by = 4;
   */
  updatedBy?: string;
};

/**
 * Describes the message guardianai.v1.fraud.UpdateReportStatusRequest.
 * Use `create(UpdateReportStatusRequestSchema)` to create a new message.
 */
export const UpdateReportStatusRequestSchema: GenMessage<UpdateReportStatusRequest, {jsonType: UpdateReportStatusRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 25);

/**
 * @generated from message guardianai.v1.fraud.AddCommentRequest
 */
export type AddCommentRequest = Message<"guardianai.v1.fraud.AddCommentRequest"> & {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string content = 3;
   */
  content: string;
};

/**
 * @generated from message guardianai.v1.fraud.AddCommentRequest
 */
export type AddCommentRequestJson = {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: string content = 3;
   */
  content?: string;
};

/**
 * Describes the message guardianai.v1.fraud.AddCommentRequest.
 * Use `create(AddCommentRequestSchema)` to create a new message.
 */
export const AddCommentRequestSchema: GenMessage<AddCommentRequest, {jsonType: AddCommentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 26);

/**
 * @generated from message guardianai.v1.fraud.CommentResponse
 */
export type CommentResponse = Message<"guardianai.v1.fraud.CommentResponse"> & {
  /**
   * @generated from field: string comment_id = 1;
   */
  commentId: string;

  /**
   * @generated from field: string report_id = 2;
   */
  reportId: string;

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * @generated from field: string content = 4;
   */
  content: string;

  /**
   * @generated from field: int64 created_at = 5;
   */
  createdAt: bigint;

  /**
   * @generated from field: bool success = 6;
   */
  success: boolean;
};

/**
 * @generated from message guardianai.v1.fraud.CommentResponse
 */
export type CommentResponseJson = {
  /**
   * @generated from field: string comment_id = 1;
   */
  commentId?: string;

  /**
   * @generated from field: string report_id = 2;
   */
  reportId?: string;

  /**
   * @generated from field: string user_id = 3;
   */
  userId?: string;

  /**
   * @generated from field: string content = 4;
   */
  content?: string;

  /**
   * @generated from field: int64 created_at = 5;
   */
  createdAt?: string;

  /**
   * @generated from field: bool success = 6;
   */
  success?: boolean;
};

/**
 * Describes the message guardianai.v1.fraud.CommentResponse.
 * Use `create(CommentResponseSchema)` to create a new message.
 */
export const CommentResponseSchema: GenMessage<CommentResponse, {jsonType: CommentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 27);

/**
 * @generated from message guardianai.v1.fraud.AddEvidenceRequest
 */
export type AddEvidenceRequest = Message<"guardianai.v1.fraud.AddEvidenceRequest"> & {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string evidence_type = 3;
   */
  evidenceType: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string file_url = 5;
   */
  fileUrl: string;
};

/**
 * @generated from message guardianai.v1.fraud.AddEvidenceRequest
 */
export type AddEvidenceRequestJson = {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: string evidence_type = 3;
   */
  evidenceType?: string;

  /**
   * @generated from field: string description = 4;
   */
  description?: string;

  /**
   * @generated from field: string file_url = 5;
   */
  fileUrl?: string;
};

/**
 * Describes the message guardianai.v1.fraud.AddEvidenceRequest.
 * Use `create(AddEvidenceRequestSchema)` to create a new message.
 */
export const AddEvidenceRequestSchema: GenMessage<AddEvidenceRequest, {jsonType: AddEvidenceRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 28);

/**
 * @generated from message guardianai.v1.fraud.EvidenceAddResponse
 */
export type EvidenceAddResponse = Message<"guardianai.v1.fraud.EvidenceAddResponse"> & {
  /**
   * @generated from field: string evidence_id = 1;
   */
  evidenceId: string;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;

  /**
   * @generated from field: string message = 3;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.fraud.EvidenceAddResponse
 */
export type EvidenceAddResponseJson = {
  /**
   * @generated from field: string evidence_id = 1;
   */
  evidenceId?: string;

  /**
   * @generated from field: bool success = 2;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 3;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.fraud.EvidenceAddResponse.
 * Use `create(EvidenceAddResponseSchema)` to create a new message.
 */
export const EvidenceAddResponseSchema: GenMessage<EvidenceAddResponse, {jsonType: EvidenceAddResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 29);

/**
 * @generated from message guardianai.v1.fraud.AssignInvestigatorRequest
 */
export type AssignInvestigatorRequest = Message<"guardianai.v1.fraud.AssignInvestigatorRequest"> & {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId: string;

  /**
   * @generated from field: string investigator_id = 2;
   */
  investigatorId: string;

  /**
   * @generated from field: string assigned_by = 3;
   */
  assignedBy: string;
};

/**
 * @generated from message guardianai.v1.fraud.AssignInvestigatorRequest
 */
export type AssignInvestigatorRequestJson = {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId?: string;

  /**
   * @generated from field: string investigator_id = 2;
   */
  investigatorId?: string;

  /**
   * @generated from field: string assigned_by = 3;
   */
  assignedBy?: string;
};

/**
 * Describes the message guardianai.v1.fraud.AssignInvestigatorRequest.
 * Use `create(AssignInvestigatorRequestSchema)` to create a new message.
 */
export const AssignInvestigatorRequestSchema: GenMessage<AssignInvestigatorRequest, {jsonType: AssignInvestigatorRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 30);

/**
 * @generated from message guardianai.v1.fraud.AssignmentResponse
 */
export type AssignmentResponse = Message<"guardianai.v1.fraud.AssignmentResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: string report_id = 3;
   */
  reportId: string;

  /**
   * @generated from field: string investigator_id = 4;
   */
  investigatorId: string;
};

/**
 * @generated from message guardianai.v1.fraud.AssignmentResponse
 */
export type AssignmentResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * @generated from field: string report_id = 3;
   */
  reportId?: string;

  /**
   * @generated from field: string investigator_id = 4;
   */
  investigatorId?: string;
};

/**
 * Describes the message guardianai.v1.fraud.AssignmentResponse.
 * Use `create(AssignmentResponseSchema)` to create a new message.
 */
export const AssignmentResponseSchema: GenMessage<AssignmentResponse, {jsonType: AssignmentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_fraud_fraud, 31);

/**
 * @generated from service guardianai.v1.fraud.FraudDetectionService
 */
export const FraudDetectionService: GenService<{
  /**
   * Analyze submission for fraud
   *
   * @generated from rpc guardianai.v1.fraud.FraudDetectionService.AnalyzeSubmission
   */
  analyzeSubmission: {
    methodKind: "unary";
    input: typeof AnalyzeSubmissionRequestSchema;
    output: typeof FraudAnalysisResponseSchema;
  },
  /**
   * Get fraud patterns
   *
   * @generated from rpc guardianai.v1.fraud.FraudDetectionService.GetFraudPatterns
   */
  getFraudPatterns: {
    methodKind: "unary";
    input: typeof GetFraudPatternsRequestSchema;
    output: typeof FraudPatternsResponseSchema;
  },
  /**
   * Report fraud
   *
   * @generated from rpc guardianai.v1.fraud.FraudDetectionService.ReportFraud
   */
  reportFraud: {
    methodKind: "unary";
    input: typeof ReportFraudRequestSchema;
    output: typeof ReportFraudResponseSchema;
  },
  /**
   * Get fraud statistics
   *
   * @generated from rpc guardianai.v1.fraud.FraudDetectionService.GetFraudStats
   */
  getFraudStats: {
    methodKind: "unary";
    input: typeof GetFraudStatsRequestSchema;
    output: typeof FraudStatsResponseSchema;
  },
  /**
   * Check velocity
   *
   * @generated from rpc guardianai.v1.fraud.FraudDetectionService.CheckVelocity
   */
  checkVelocity: {
    methodKind: "unary";
    input: typeof CheckVelocityRequestSchema;
    output: typeof VelocityResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_fraud_fraud, 0);

/**
 * @generated from service guardianai.v1.fraud.FraudReportService
 */
export const FraudReportService: GenService<{
  /**
   * Submit a new fraud report
   *
   * @generated from rpc guardianai.v1.fraud.FraudReportService.SubmitFraudReport
   */
  submitFraudReport: {
    methodKind: "unary";
    input: typeof SubmitReportRequestSchema;
    output: typeof FraudReportResponseSchema;
  },
  /**
   * Get a fraud report by ID
   *
   * @generated from rpc guardianai.v1.fraud.FraudReportService.GetFraudReport
   */
  getFraudReport: {
    methodKind: "unary";
    input: typeof GetReportRequestSchema;
    output: typeof FraudReportResponseSchema;
  },
  /**
   * Update an existing fraud report
   *
   * @generated from rpc guardianai.v1.fraud.FraudReportService.UpdateReport
   */
  updateReport: {
    methodKind: "unary";
    input: typeof UpdateReportRequestSchema;
    output: typeof FraudReportResponseSchema;
  },
  /**
   * List fraud reports with filters
   *
   * @generated from rpc guardianai.v1.fraud.FraudReportService.ListReports
   */
  listReports: {
    methodKind: "unary";
    input: typeof ListReportsRequestSchema;
    output: typeof ListReportsResponseSchema;
  },
  /**
   * Get fraud report analytics
   *
   * @generated from rpc guardianai.v1.fraud.FraudReportService.GetReportAnalytics
   */
  getReportAnalytics: {
    methodKind: "unary";
    input: typeof GetReportAnalyticsRequestSchema;
    output: typeof ReportAnalyticsResponseSchema;
  },
  /**
   * Get available fraud categories
   *
   * @generated from rpc guardianai.v1.fraud.FraudReportService.GetFraudCategories
   */
  getFraudCategories: {
    methodKind: "unary";
    input: typeof GetFraudCategoriesRequestSchema;
    output: typeof FraudCategoriesResponseSchema;
  },
  /**
   * Get reports submitted by a specific user
   *
   * @generated from rpc guardianai.v1.fraud.FraudReportService.GetUserSubmittedReports
   */
  getUserSubmittedReports: {
    methodKind: "unary";
    input: typeof GetUserReportsRequestSchema;
    output: typeof ListReportsResponseSchema;
  },
  /**
   * Get reports assigned to a specific investigator
   *
   * @generated from rpc guardianai.v1.fraud.FraudReportService.GetInvestigatorAssignedReports
   */
  getInvestigatorAssignedReports: {
    methodKind: "unary";
    input: typeof GetInvestigatorReportsRequestSchema;
    output: typeof ListReportsResponseSchema;
  },
  /**
   * Update the status of a fraud report
   *
   * @generated from rpc guardianai.v1.fraud.FraudReportService.UpdateFraudReportStatus
   */
  updateFraudReportStatus: {
    methodKind: "unary";
    input: typeof UpdateReportStatusRequestSchema;
    output: typeof FraudReportResponseSchema;
  },
  /**
   * Add a comment to a fraud report
   *
   * @generated from rpc guardianai.v1.fraud.FraudReportService.AddCommentToReport
   */
  addCommentToReport: {
    methodKind: "unary";
    input: typeof AddCommentRequestSchema;
    output: typeof CommentResponseSchema;
  },
  /**
   * Add evidence to a fraud report
   *
   * @generated from rpc guardianai.v1.fraud.FraudReportService.AddEvidenceToReport
   */
  addEvidenceToReport: {
    methodKind: "unary";
    input: typeof AddEvidenceRequestSchema;
    output: typeof EvidenceAddResponseSchema;
  },
  /**
   * Assign a fraud report to an investigator
   *
   * @generated from rpc guardianai.v1.fraud.FraudReportService.AssignReportToInvestigator
   */
  assignReportToInvestigator: {
    methodKind: "unary";
    input: typeof AssignInvestigatorRequestSchema;
    output: typeof AssignmentResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_fraud_fraud, 1);

